module.exports = __webpack_public_path__ + "img/Cursos personalizados.52933b88.svg";